"use client";
import ClinicPriceList from "@kkeut/ui/clinic-price-list";
import { useLocale } from "@/components/LocaleProvider";
const BRANCH_ID = (process.env.NEXT_PUBLIC_BRANCH_ID || "").trim() || "guro";
export default function ClinicPrice(props) {
  const { locale } = useLocale();
  return <ClinicPriceList {...props} branchId={BRANCH_ID} locale={locale} />;
}
